import type { GmGameView } from '#src/interfaces/gameManager'

const resolveDevLocalGameLaunchUrl = (game: GmGameView): string | undefined => {
  if (!import.meta.env.DEV) {
    return undefined
  }

  if (import.meta.env.VITE_DEV_LOCAL_GAME_ENABLED !== 'true') {
    return undefined
  }

  const displayId = import.meta.env.VITE_DEV_LOCAL_GAME_DISPLAY_ID?.trim()
  const url = import.meta.env.VITE_DEV_LOCAL_GAME_URL?.trim()

  if (!displayId || !url || game.displayId !== displayId) {
    return undefined
  }

  return url
}

export { resolveDevLocalGameLaunchUrl }
